<template>
    <div>
        <form :id="'therapy_form_' + rowID" @submit.prevent="submitFormData">
             <div class="form-group">
                <label class="form-label">{{$t('label.title')}}</label>
                <div class="input-group bg-white shadow-inset-2">
                    <div class="input-group-prepend">
                        <span class="input-group-text bg-transparent border-right-0">
                            <i class="fas fa-text"></i>
                        </span>
                    </div>
                    <input type="text" class="form-control bg-transparent pl-3" :placeholder="$t('label.title')" v-model="title" required="">
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12 col-md-6 mb-2">
                    <div class="form-group">
                        <label class="form-label">{{$t('label.unit_price')}}</label>
                        <div class="input-group bg-white shadow-inset-2">
                            <div class="input-group-prepend">
                                <span class="input-group-text bg-transparent border-right-0">
                                    <i class="fas fa-dollar-sign"></i>
                                </span>
                            </div>
                            <input class="form-control service_row_num" type="number" step="any"
                                v-model="unitPrice" 
                                @keypress="isNumber($event)"
                            />
                            <!-- <input type="text" class="form-control bg-transparent pl-3" :placeholder="$t('label.unit_price')" @keypress="isNumber($event)" v-model="unitPrice" required=""> -->
                        </div>
                    </div>
                </div>
                <div class="col-sm-12 col-md-6 mb-2">
                    <div class="form-group">
                        <label class="form-label">{{$t('table.header.voucher')}}</label>
                        <div class="input-group bg-white shadow-inset-2">
                            <div class="input-group-prepend">
                                <span class="input-group-text bg-transparent border-right-0">
                                        <i class="fas fa-ticket-alt"></i>
                                </span>
                            </div>
                            <input ref="voucherInput" block v-b-toggle="'accItem_' + rowID" @keydown.prevent class="form-control bg-transparent pl-3" :placeholder="$t('table.header.voucher')" v-model="selectedVoucher" required="">
                        </div>
                    </div>
                </div>
            </div>
            <b-collapse :id="'accItem_' + rowID" accordion="accordion" role="tabpanel">
                <b-card no-body>
                    <b-card-body>
                        <h5 class="card-title">{{$t('header.list_of', {'item': $t('table.header.voucher')})}}</h5>
                        <div class="row mb-2">
                            <div class="col-md-12 col-sm-12">
                                <div class="dataTables_filter mb-2">
                                    <label class="d-flex mb-0">
                                        <input type="search" class="form-control border-top-right-radius-0 border-bottom-right-radius-0 ml-0 shadow-inset-1" :placeholder="$t('label.search')" v-model="searchItem" @keypress.enter="filterSearchItem">
                                        <button type="button" class="input-group-text d-inline-flex width-3 align-items-center justify-content-center border-bottom-left-radius-0 border-top-left-radius-0 border-left-0 search" @click="filterSearchItem">
                                            <i class="fas fa-search"></i>
                                        </button>
                                    </label>
                                </div>
                                <a class="link text-primary" @click="clearFilter">{{$t('button_link.clear_filter')}}</a>
                            </div>
                        </div>
                        <ul class="nav nav-tabs mb-3">
                            <li class="nav-item" v-for="c in category" :key="c.id">
                                <a :class="{'active': selectedCategory == c.id}" class="nav-link" role="tab" @click="filterCategory(c.id)">{{c.text}}</a>
                            </li>
                        </ul>
                        <div class="demo package-list">
                            <button v-for="s in voucherItems" :key="s.itemID" type="button" class="btn btn-lg btn-outline-primary waves-effect waves-themed text-left fs-md" @click="selectItem(s.itemID, s.title)">
                                <span class="d-block">{{s.title}}</span>
                                <span class="d-block border-top pt-1 mt-1"><i class="fas fa-tag mr-2"></i>{{getCategoryText(s.category)}}</span>
                                <span class="d-block border-top pt-1 mt-1"><i class="fas fa-dollar-sign mr-3"></i>{{formatPrice(s.price)}} {{$t('label.ea')}}.</span>
                            </button>
                            <div class="panel-tag mt-3" v-if="voucherItems != undefined && voucherItems.length == 0">{{$t('table.no_records')}}</div>
                        </div>
                    </b-card-body>
                </b-card>
            </b-collapse>
            <div class="mt-3 form-group">
                <label class="form-label">{{$t('label.details')}}</label>
                <textarea class="form-control" :placeholder="$t('label.details')" rows="5" v-model="details"></textarea>
            </div>
        </form>
    </div>
</template>
<script>
import {isNumber, formatPrice} from '../../../../assets/js/dashboard/utilities'
import {handleSessionExpired, getCategoryText} from '../../../../assets/js/dashboard/dashboard'
export default {
    name: 'therapyForm',
    props:{
        treatmentID: Number,
        rowID: { type: Number },
        items: { type: Object }
    },
    data(){
        var itemID = this.items != undefined ? this.items.TnTherapyID : 0
        var title = this.items != undefined ? this.items.TnTherapyName : ""
        var details = this.items != undefined ? this.items.TnTherapyDetails : ""
        var unitPrice = this.items != undefined ? this.items.TnTherapyUnitPrice : 0
        var selectedVoucher = this.items != undefined ? this.items.TnTherapyVoucherName : ""
        var selectedVoucherID = this.items != undefined ? this.items.TnTherapyVoucherID : 0
        return{
            voucherItems:[],
            itemID: itemID,
            title: title, 
            details: details,
            unitPrice: unitPrice,
            selectedVoucher: selectedVoucher,
            selectedVoucherID: selectedVoucherID,
            searchItem: "",
            category: [], 
            selectedCategory: "all",
            voucher: ""
        }
    },
    watch:{
        "$i18n.locale"(val){
            this.setCategory()
        },
    },
    methods: {
        formatPrice(p){
            return formatPrice(p)
        },
        isNumber(e){
            return isNumber(e);
        },
        getCategoryText(id){
            return getCategoryText(id, this.category)
        },
        resetForm(){
            this.title = this.details = ""
            this.unitPrice = 0
        },
        closeModal(isError){
            if(!isError){
                this.returnTherapy()
                this.resetForm()
            }
            
            this.$parent.$parent.$parent.$parent.isModalShow = false
        },
        returnTherapy(){
            this.$emit('returnTherapy');
        },
        editTherapy(item){
            this.itemID = item.TnTherapyID;
            this.title = item.TnTherapyName
            this.details = item.TnTherapyDetails
            this.unitPrice = item.TnTherapyUnitPrice

            var voucherObj = this.voucherItems.filter(obj=> obj.itemID == item.TnTherapyVoucherID)[0]
            this.selectedVoucherID = voucherObj.itemID
            this.selectedVoucher = voucherObj.title
        },
        setFormData(){
            var data = {
                itemID: this.itemID,
                TnTherapyName: this.title,
                TnTherapyDetails: this.details, 
                TnTherapyUnitPrice: this.unitPrice, 
                TnTreatmentID: this.treatmentID,
                TnTherapyVoucherID: this.selectedVoucherID,
                TnTherapyVoucherName: this.selectedVoucher
            }
            return data
        },
        submitFormData(){
            var data = this.setFormData()

            let _url = this.$api.MENU_THERAPY
            let url = this.isEdit ?  _url + "/" + this.itemID + this.$api.UPDATE : _url

            let $vm = this
            $vm.$axios({
                method: 'post', 
                url: url,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')},
                data: data,
            })
            .then((response) => {
                if(response.status == 200){
                    var action = $vm.isEdit ? $vm.$i18n.t('message.success.action.update') : $vm.$i18n.t('message.success.action.add')
                    var retData = response.data[0];
                    var message = retData.TnTherapyName + "' " + $vm.$i18n.t('message.success.success', {'action': action})
                    $vm.$parent.$parent.$parent.setModal($vm, false, true, message);
                }
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();  
                }else{
                    $vm.$parent.$parent.$parent.setModal($vm, true, true,  $vm.$i18n.t('message.error.system_error'));
                }
            })
        },
        clearFilter(){
            this.searchItem = ""
            this.selectedCategor = "all"
            this.filterVoucherItems()
        },
        filterCategory(id){
            this.selectedCategory = id;
            this.filterVoucherItems()
        },
        filterSearchItem(){
            this.selectedCategory = "all";
            this.filterVoucherItems()
        },
        filterVoucherItems(){
            var categoryFilter = this.selectedCategory == "all" ? "" : "&category=" + this.selectedCategory;
            var searchFilter = this.searchItem == "" ? "" : "&search=" + this.searchItem;

            let QUERY_STRING = categoryFilter + searchFilter;
            this.getVoucherItems(QUERY_STRING)
        },
        async getVoucherItems(strFilter){
            let $vm = this;
            let QUERY_STRING =  "?type=service" + strFilter
            const url =  this.$api.MENU_ITEM + QUERY_STRING;

            await $vm.$axios({
                method: 'get', 
                url: url,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) {
                $vm.voucherItems = response.data.items;
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
        },
        selectItem(id, title){
            
            this.selectedVoucherID = id;
            this.selectedVoucher = title;
            this.$refs.voucherInput.click()
        },
        setCategory(){
            this.category = []
            var category = JSON.parse(this.$store.state.category);
            this.category.push({id: "all", text: this.$i18n.t('label.all', {'item': this.$i18n.t('label.category')})});
            
            for(var i=0; i<category.service.length; i++){
                this.category.push({id: i, text: category.service[i]});
            }
        }
    },
    async mounted(){
        let $vm = this;
        $vm.setCategory()
        await $vm.getVoucherItems("");
    }
}
</script>